import React, { useEffect, useState } from 'react';

import { DrawerComponent } from 'components/Drawer';
import { api } from 'services/api';
import loadingIcon from 'assets/image/loading.svg';
import * as S from './styles';
import {
  capitalizeFirstLetter,
  formattedValue,
  SumArrayOfNumbers,
  trimString,
} from 'helpers/util';
import { Line } from 'components/Line';
import { ToolTip } from 'components/ToolTip';
import { InvoiceStatus } from 'components/InvoiceStatus';

interface IDetailsService {
  closeDrawer: () => void;
  invoiceDate?: string;
  issuanceDate?: string;
  paymentDate?: string;
  idBilling: string | undefined;
  title: string;
}
type ProductsProps = {
  ds_product: string;
  value: string;
  id_compo_billing: string;
  complement: string | null;
};
type BillingProps = {
  id_billing: number;
  complement?: string;
  status?: string;
};

type CompoBillingProps = {
  name: string;
  products: ProductsProps[];
  id_product: string;
  complement: string | null;
  id_plan: string;
  id_signature: number;
};
const DetailsService = ({
  closeDrawer,
  idBilling,
  invoiceDate,
  issuanceDate,
  title,
}: IDetailsService) => {
  const [isLoading, setIsLoading] = useState(false);
  const [billing, setBilling] = useState<BillingProps>();
  const [compoBilling, setCompoBilling] = useState<CompoBillingProps[]>([]);
  const accessToken = localStorage.getItem('accessToken');
  const idToken = localStorage.getItem('idToken');
  const fetchDataBillings = async () => {
    setIsLoading(true);
    try {
      const { data } = await api.get(`client/billings/${idBilling}`, {
        headers: {
          'content-Type': 'application/json',
          Authorization: `Bearer ${accessToken}`,
          idToken,
        },
      });
      setBilling(data.data);
      setCompoBilling(data.data.compo_billing);
      setIsLoading(false);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchDataBillings();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const numberValues = compoBilling?.map((item) =>
    item?.products?.map((value) => Number(value.value)),
  );

  const newArrayProductValues =
    numberValues && ([] as number[])?.concat(...numberValues);

  const Loader = () => {
    return (
      <S.Loader>
        <img src={loadingIcon} width={36} height={36} />
      </S.Loader>
    );
  };
  const formatComplementBilling = (text: string | null) => {
    if (text) return trimString(text, 16);
    return '-';
  };
  return (
    <DrawerComponent
      open
      size="default"
      // className={styles.drawer}
      onCompleteClose={closeDrawer}
      titleClose={'Detalhes da fatura'}
    >
      {isLoading ? (
        <Loader />
      ) : (
        <>
          <S.WrapperInvoiceDetail>
            <div>
              <p>{title}</p>
              <S.SubTitle>
                Criado em {issuanceDate} • Vence em {invoiceDate}
              </S.SubTitle>
            </div>
            {billing?.status && (
              <InvoiceStatus
                text={`${capitalizeFirstLetter(billing?.status)}`}
                status={billing?.status}
                colortText="black"
              />
            )}
          </S.WrapperInvoiceDetail>
          <S.ContentDetails>
            <header>
              <span>Descrição</span>
              <span>Cobrança</span>
              <span style={{ textAlign: 'end' }}>Valor</span>
            </header>
            <Line width="100%" border="1px" />
            <div className="contentPlan">
              {compoBilling?.map((item, index) => {
                return (
                  <span key={item?.id_plan}>
                    <ul className="planName">
                      <li className="planName-row">
                        {item?.name ? item.name : '-'}
                      </li>
                      <li className="planName-row">
                        {billing?.complement ? (
                          <ToolTip
                            content={billing.complement}
                            text={formatComplementBilling(billing.complement)}
                          />
                        ) : (
                          '-'
                        )}
                      </li>
                      <li
                        className="planName-row__value"
                        style={{ textAlign: 'end' }}
                      >
                        {formattedValue(SumArrayOfNumbers(numberValues[index]))}
                      </li>
                    </ul>
                    <Line width="100%" border="1px" />
                    {item.products.map((products: ProductsProps) => {
                      return (
                        <ul
                          className="additionalPlan"
                          key={products.id_compo_billing}
                        >
                          <li className="additionalPlan-row">
                            {products.ds_product}
                          </li>
                          <li className="additionalPlan-row">
                            {products.complement ? (
                              <ToolTip
                                content={products.complement}
                                text={trimString(products.complement, 14)}
                              />
                            ) : (
                              '-'
                            )}
                          </li>
                          <li
                            className="additionalPlan-row__value"
                            style={{ textAlign: 'end' }}
                          >
                            {formattedValue(Number(products.value))}
                          </li>
                        </ul>
                      );
                    })}
                  </span>
                );
              })}
            </div>
            <Line width="100%" border="1px" />
            <footer>
              <span className="totalValue">
                {formattedValue(SumArrayOfNumbers(newArrayProductValues))}
              </span>
            </footer>
          </S.ContentDetails>
        </>
      )}
    </DrawerComponent>
  );
};
export default DetailsService;
